import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=7b38c82f&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=7b38c82f&prod&scoped=true&lang=css"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=7b38c82f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b38c82f",
  null
  
)

export default component.exports